import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  InterceptorUtil,
  LoggerService,
  normalizeHttpError,
  OccEndpointsService,
  USE_CLIENT_TOKEN,
} from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ProductVerificationAdapter } from './product-verification.adapter';

@Injectable({
  providedIn: 'root',
})
export class OccProductVerificationAdapter implements ProductVerificationAdapter {
  protected logger = inject(LoggerService);

  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService
  ) {}

  isApplianceOnRecallList(serialNumber: string, applianceCode: string): Observable<boolean> {
    const url = this.occEndpoints.buildUrl('productVerification');

    let headers = new HttpHeaders();
    headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);

    return this.http
      .post<boolean>(url, null, {
        params: { serialNumber, applianceCode },
        headers: headers,
      })
      .pipe(catchError((error) => throwError(normalizeHttpError(error, this.logger))));
  }
}
